<template>
  <MetricView view-name="finance" />
</template>

<script lang="ts" setup>
import MetricView from '@/components/MetricView.vue';
</script>
